<template>
  <vx-table-simple
    :items="items"
    :columns="columns"
  />
</template>

<script>
import { VxTableSimple } from '@/components/table'
import { inject } from '@vue/composition-api'

export default {
  name: 'PermissionsDetails',
  components: {
    VxTableSimple
  },
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  setup ({ data }) {
    const {
      getColumns
    } = inject('permissionsStore')

    const items = data.item.groups || []

    const columns = getColumns(true)

    return {
      items,
      columns
    }
  }
}
</script>
